// extracted by mini-css-extract-plugin
export default {"titleWrap":"Title_titleWrap__-3M1U"};